import React from 'react';
import IHasItemDataProps from './IHasItemDataProps';
import IHasItemEventProps from './IHasItemEventProps';
import { IItemWithoutShowSellerProps } from './IItemProps';
import SharedPurchaseItemCells from './SharedPurchaseItemCells';
import { IBuyerDepositViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';

interface IBuyerDepositProps
  extends IItemWithoutShowSellerProps,
    IHasItemDataProps<IBuyerDepositViewItem>,
    IHasItemEventProps<IBuyerDepositViewItem> {
  onFocus?: () => void;
  onBlur?: (event: React.FocusEvent) => void;
}

const BuyerDeposit = (props: IBuyerDepositProps) => (
  <SharedPurchaseItemCells
    buyerBeforeClosingDisplay="input"
    {...props}
    showRemove={false}
    hasEditPermissions={props.hasEditPermissions}
  >
    Deposit
  </SharedPurchaseItemCells>
);

export default BuyerDeposit;
